var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.documentsArray.length !== 0
      ? _c(
          "div",
          [
            _c(
              "h3",
              {
                staticClass: "text-center bold",
                staticStyle: { "margin-bottom": "30px" },
              },
              [_vm._v("Document Submission")]
            ),
            _c(
              "h4",
              {
                staticClass: "text-center",
                staticStyle: { "margin-bottom": "30px" },
              },
              [_vm._v("Document Instructions")]
            ),
            _c(
              "div",
              {
                staticClass: "text-center",
                staticStyle: { "margin-bottom": "40px" },
              },
              [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.formattedText()) },
                }),
              ]
            ),
            _c(
              "div",
              [
                _vm.documentsArray && _vm.documentsArray.length > 0
                  ? _c("md-table", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "md-table-row",
                            fn: function (ref) {
                              var item = ref.item
                              return _c(
                                "md-table-row",
                                {},
                                [
                                  _c(
                                    "md-table-cell",
                                    {
                                      attrs: {
                                        "md-label": "Document",
                                        "md-sort-by": "documentName",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.documentName))]
                                  ),
                                  _c(
                                    "md-table-cell",
                                    {
                                      attrs: {
                                        "md-label": "Verification Status",
                                        "md-sort-by": "isVerified",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.isVerified
                                              ? "Verified"
                                              : "Not Verified"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "md-table-cell",
                                    {
                                      attrs: {
                                        "md-label": "Resubmit Required",
                                        "md-sort-by": "shouldResubmit",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.shouldResubmit ? "Yes" : "No"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "md-table-cell",
                                    [
                                      item.url
                                        ? _c(
                                            "md-button",
                                            {
                                              staticClass: "md-success",
                                              staticStyle: { width: "100px" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.previewDocument(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" View ")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("md-table-cell", [
                                    _c(
                                      "div",
                                      [
                                        _c("input", {
                                          ref: "fileInput",
                                          staticStyle: { display: "none" },
                                          attrs: {
                                            type: "file",
                                            accept: "application/pdf",
                                          },
                                          on: { change: _vm.handleFileChange },
                                        }),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass: "md-info button",
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              id: "upload-btn-" + item.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showFileDialog(item)
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.shouldResubmit
                                                    ? "Resubmit"
                                                    : "Submit"
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c("md-table-cell", [
                                    _c(
                                      "span",
                                      {
                                        style: {
                                          color:
                                            item.isVerified &&
                                            !item.shouldResubmit
                                              ? "green"
                                              : "red",
                                          fontSize: "1rem",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.isVerified &&
                                                !item.shouldResubmit
                                                ? "✅"
                                                : "❌"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            },
                          },
                        ],
                        null,
                        false,
                        2122574918
                      ),
                      model: {
                        value: _vm.documentsArray,
                        callback: function ($$v) {
                          _vm.documentsArray = $$v
                        },
                        expression: "documentsArray",
                      },
                    })
                  : _c("div", [_vm._v("No Documents Requested.")]),
              ],
              1
            ),
            _c(
              "md-dialog",
              {
                staticStyle: { "min-width": "70% !important" },
                attrs: { "md-active": _vm.showUploadProgress },
                on: {
                  "update:mdActive": function ($event) {
                    _vm.showUploadProgress = $event
                  },
                  "update:md-active": function ($event) {
                    _vm.showUploadProgress = $event
                  },
                },
              },
              [
                !_vm.uploadSuccess
                  ? _c("md-dialog-title", [
                      _vm._v(
                        " Uploading " +
                          _vm._s(
                            _vm.currentDocument
                              ? _vm.currentDocument.documentName
                              : "Document"
                          )
                      ),
                    ])
                  : _c("md-dialog-title", [
                      _vm._v("Success! 🥳 Upload Successful!"),
                    ]),
                _c("md-dialog-content", [
                  !_vm.uploadSuccess
                    ? _c(
                        "div",
                        [
                          _c("md-progress-bar", {
                            attrs: {
                              "md-value": _vm.uploadPercentage,
                              "md-buffer": 100,
                            },
                          }),
                          _c("p", [_vm._v(_vm._s(_vm.uploadPercentage) + "%")]),
                        ],
                        1
                      )
                    : _c("div", [
                        _c("p", [
                          _vm._v(
                            'The document "' +
                              _vm._s(
                                _vm.currentDocument
                                  ? _vm.currentDocument.documentName
                                  : "Document"
                              ) +
                              '" was uploaded successfully!'
                          ),
                        ]),
                      ]),
                ]),
                _c(
                  "md-dialog-actions",
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-primary",
                        attrs: { disabled: !_vm.uploadSuccess },
                        on: { click: _vm.closeUploadModal },
                      },
                      [_vm._v("Close")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _c("div", [
          _c(
            "h3",
            {
              staticClass: "text-center bold",
              staticStyle: { "margin-top": "50px" },
            },
            [_vm._v("There are no documents to submit")]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }